import {ApiLink} from "./urls";

const SendVote = async (items, token) => {
    localStorage.setItem("glgltz_vote_int", "true");
    const response = await fetch(`${ApiLink()}Vote?token=${token}`, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(items)
    });

    response.text().then(data => {console.log(data)});
}
export {SendVote}